import { AWAITING_LAUNCH } from "@/config/tokenData";

export const LaunchBadge = ({ className = "", testId = "launch-badge" }) => (
  <span className={`launch-badge ${className}`} data-testid={testId} role="status">
    <span className="launch-badge__dot" aria-hidden="true" />
    {AWAITING_LAUNCH}
  </span>
);
